// @generated by protoc-gen-es v2.2.3 with parameter "target=js+dts"
// @generated from file anu/cat_app/roles.proto (package anu.cat_app, syntax proto3)
/* eslint-disable */

import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv1";
import { file_anu_cat_app_enums } from "./enums_pb";
import { file_anu_cat_app_user } from "./user_pb";
import { file_buf_validate_validate } from "../../buf/validate/validate_pb";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import { file_patch_go } from "../../patch/go_pb";

/**
 * Describes the file anu/cat_app/roles.proto.
 */
export const file_anu_cat_app_roles = /*@__PURE__*/
  fileDesc("ChdhbnUvY2F0X2FwcC9yb2xlcy5wcm90bxILYW51LmNhdF9hcHAiRwoTQWRkU2l0ZVJvbGVzUmVxdWVzdBIwCglzaXRlX3JvbGUYASABKAsyFS5hbnUuY2F0X2FwcC5TaXRlUm9sZUIGukgDyAEBIhYKFEFkZFNpdGVSb2xlc1Jlc3BvbnNlIkoKFlJlbW92ZVNpdGVSb2xlc1JlcXVlc3QSMAoJc2l0ZV9yb2xlGAEgASgLMhUuYW51LmNhdF9hcHAuU2l0ZVJvbGVCBrpIA8gBASIZChdSZW1vdmVTaXRlUm9sZXNSZXNwb25zZSKUAQoIU2l0ZVJvbGUSFwoHc2l0ZV9pZBgBIAEoCUIGukgDyAEBEjkKDHNpdGVfcm9sZV9pZBgCIAEoDjIXLmFudS5jYXRfYXBwLlNpdGVSb2xlSURCCrpIB4IBBBABIAASNAoHbWVtYmVycxgDIAMoCzIbLmFudS5jYXRfYXBwLlJvbGVVc2VyTWVtYmVyQga6SAPIAQEiRAoSQWRkT3JnUm9sZXNSZXF1ZXN0Ei4KCG9yZ19yb2xlGAEgASgLMhQuYW51LmNhdF9hcHAuT3JnUm9sZUIGukgDyAEBIhUKE0FkZE9yZ1JvbGVzUmVzcG9uc2UiRwoVUmVtb3ZlT3JnUm9sZXNSZXF1ZXN0Ei4KCG9yZ19yb2xlGAEgASgLMhQuYW51LmNhdF9hcHAuT3JnUm9sZUIGukgDyAEBIhgKFlJlbW92ZU9yZ1JvbGVzUmVzcG9uc2UikgEKB09yZ1JvbGUSGAoIb3JnX2NvZGUYASABKAlCBrpIA8gBARI3Cgtvcmdfcm9sZV9pZBgCIAEoDjIWLmFudS5jYXRfYXBwLk9yZ1JvbGVJREIKukgHggEEEAEgABI0CgdtZW1iZXJzGAMgAygLMhsuYW51LmNhdF9hcHAuUm9sZVVzZXJNZW1iZXJCBrpIA8gBASK6AQoOUm9sZVVzZXJNZW1iZXISFwoHdXNlcl9pZBgBIAEoCUIGukgDyAEBEjMKD3N0YXJ0X3RpbWVzdGFtcBgCIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5UaW1lc3RhbXASMQoNZW5kX3RpbWVzdGFtcBgDIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5UaW1lc3RhbXASJwoMdXNlcl9kZXRhaWxzGAQgASgLMhEuYW51LmNhdF9hcHAuVXNlckIzWitnaXRodWIuY29tL2FudS1pdHMvY2F0LWdycGMtYXBwLXBiO2NhdGFwcHBiyrUDAggBYgZwcm90bzM", [file_anu_cat_app_enums, file_anu_cat_app_user, file_buf_validate_validate, file_google_protobuf_timestamp, file_patch_go]);

/**
 * Describes the message anu.cat_app.AddSiteRolesRequest.
 * Use `create(AddSiteRolesRequestSchema)` to create a new message.
 */
export const AddSiteRolesRequestSchema = /*@__PURE__*/
  messageDesc(file_anu_cat_app_roles, 0);

/**
 * Describes the message anu.cat_app.AddSiteRolesResponse.
 * Use `create(AddSiteRolesResponseSchema)` to create a new message.
 */
export const AddSiteRolesResponseSchema = /*@__PURE__*/
  messageDesc(file_anu_cat_app_roles, 1);

/**
 * Describes the message anu.cat_app.RemoveSiteRolesRequest.
 * Use `create(RemoveSiteRolesRequestSchema)` to create a new message.
 */
export const RemoveSiteRolesRequestSchema = /*@__PURE__*/
  messageDesc(file_anu_cat_app_roles, 2);

/**
 * Describes the message anu.cat_app.RemoveSiteRolesResponse.
 * Use `create(RemoveSiteRolesResponseSchema)` to create a new message.
 */
export const RemoveSiteRolesResponseSchema = /*@__PURE__*/
  messageDesc(file_anu_cat_app_roles, 3);

/**
 * Describes the message anu.cat_app.SiteRole.
 * Use `create(SiteRoleSchema)` to create a new message.
 */
export const SiteRoleSchema = /*@__PURE__*/
  messageDesc(file_anu_cat_app_roles, 4);

/**
 * Describes the message anu.cat_app.AddOrgRolesRequest.
 * Use `create(AddOrgRolesRequestSchema)` to create a new message.
 */
export const AddOrgRolesRequestSchema = /*@__PURE__*/
  messageDesc(file_anu_cat_app_roles, 5);

/**
 * Describes the message anu.cat_app.AddOrgRolesResponse.
 * Use `create(AddOrgRolesResponseSchema)` to create a new message.
 */
export const AddOrgRolesResponseSchema = /*@__PURE__*/
  messageDesc(file_anu_cat_app_roles, 6);

/**
 * Describes the message anu.cat_app.RemoveOrgRolesRequest.
 * Use `create(RemoveOrgRolesRequestSchema)` to create a new message.
 */
export const RemoveOrgRolesRequestSchema = /*@__PURE__*/
  messageDesc(file_anu_cat_app_roles, 7);

/**
 * Describes the message anu.cat_app.RemoveOrgRolesResponse.
 * Use `create(RemoveOrgRolesResponseSchema)` to create a new message.
 */
export const RemoveOrgRolesResponseSchema = /*@__PURE__*/
  messageDesc(file_anu_cat_app_roles, 8);

/**
 * Describes the message anu.cat_app.OrgRole.
 * Use `create(OrgRoleSchema)` to create a new message.
 */
export const OrgRoleSchema = /*@__PURE__*/
  messageDesc(file_anu_cat_app_roles, 9);

/**
 * Describes the message anu.cat_app.RoleUserMember.
 * Use `create(RoleUserMemberSchema)` to create a new message.
 */
export const RoleUserMemberSchema = /*@__PURE__*/
  messageDesc(file_anu_cat_app_roles, 10);

